import React from "react"

// antd
import { Tag } from "antd"
import { LoadingOutlined } from "@ant-design/icons"

// i18n
import { useTranslation } from "react-i18next"

const OrderStatusTag = ({ order }) => {
  const { t } = useTranslation()

  let statusText = ""

  switch (order.status) {
    case "awaiting-for-payment":
      statusText = t("waiting_payment")
      break
    case "created":
      statusText = t("waiting_acceptance")
      break
    case "refused":
      statusText = t("refused_status")
      break
    case "accepted":
      statusText = t("in_progress")
      break
    case "finished":
      statusText =
        order.type === "delivery" ? t("being_delivered") : t("ready_for_pickup")
      break
    case "cancelled-by-user":
      statusText = t("cancelled_status")
      break

    default:
      statusText = t("unknown_status")
  }

  if (order.completed && order.status === "finished") {
    statusText = t("completed_status")
  }

  let color = "default"
  if (order.status === "finished") color = "green"
  else if (order.status === "accepted" || order.status === "created")
    color = "blue"
  else if (order.status === "cancelled-by-user") color = "red"
  else if (order.status === "refused") color = "orange"

  return (
    <Tag
      icon={
        order.status === "created" || order.status === "accepted" ? (
          <LoadingOutlined />
        ) : null
      }
      style={{ wordBreak: "break-word", whiteSpace: "pre-wrap" }}
      color={color}
    >
      {statusText}
    </Tag>
  )
}

export default OrderStatusTag
